/**
 * Theme configuration for the application.
 * User-facing themes are available to all users.
 * Dev themes are only shown when dev mode is enabled.
 */

export interface ThemeDefinition {
  id: string;
  name: string;
  description: string;
}

/** User-facing themes available to all users */
export const USER_THEMES: ThemeDefinition[] = [
  { id: 'default', name: 'Default', description: 'Standard game theme' },
  { id: 'terminal', name: 'Terminal', description: 'Dark terminal with green accents' },
  { id: 'industrial', name: 'Industrial', description: 'Dark factory aesthetic with amber' },
];

/** Additional themes only visible in dev mode */
export const DEV_THEMES: ThemeDefinition[] = [
  { id: 'excel', name: 'Excel', description: 'Spreadsheet-inspired flat design' },
  { id: 'financial', name: 'Financial', description: 'Professional dashboard with blue accents' },
  { id: 'retro', name: 'Retro', description: 'Windows 95/2000 classic style' },
  { id: 'macos', name: 'Mac OS', description: 'Classic Mac OS with rounded corners' },
];

/** All themes (for internal use and DevThemeSwitcher) */
export const THEMES: ThemeDefinition[] = [...USER_THEMES, ...DEV_THEMES];

/** Get available themes based on dev mode state */
export function getAvailableThemes(isDevMode: boolean): ThemeDefinition[] {
  return isDevMode ? THEMES : USER_THEMES;
}

export const DEFAULT_THEME = 'default';
export const THEME_STORAGE_KEY = 'smartphone-simulator-theme';
